import React, { useEffect } from 'react'
import { useTranslation } from 'react-i18next'

import { OutletFulfilmentSection } from '@src/components/OutletServicePopover/OutletFulfilmentSection'
import { OutletTimeSection } from '@src/components/OutletServicePopover/OutletTimeSection'
import { AllLocationSection } from '@src/components/ServicePopover/AllLocationSection'
import { SectionHeader } from '@src/components/ServicePopover/SectionHeader'
import { BottomSheet } from '@src/components/BottomSheet/BottomSheet'
import {
  MobileNavigationPopoverContentWrapper,
  MobileNavigationPopoverContent,
  Separator,
  MobileNavigationPopoverFooter,
  MobileNavigationPopoverFooterContent,
  MobileNavigationResetLink,
  DoneButton,
  SectionContentContainer,
} from '@src/components/BottomSheet/BottomSheet.styles'
import { SingleOutletWithDeliveryWindows } from '@src/components/SingleOutlet/types'
import { NarrowFulfilmentMethodInputType } from '@src/graphql-types'
import {
  OutletFulfilmentStateType,
  useOutletFulfilment,
} from '@src/hooks/outletFulfilmentAndBasketHooks/useOutletFulfilment/useOutletFulfilment'
import { useBottomSheetStack } from '@src/hooks/useBottomSheetStack/useBottomSheetStack'

export const MobileOutletServicePopover: React.FC = () => {
  const { serviceComponentBottomSheetController } = useBottomSheetStack()
  const { t } = useTranslation('serviceNavigation')
  const outletFulfilment = useOutletFulfilment({
    stateType: OutletFulfilmentStateType.LOCAL,
  })
  const { narrowType: currentNarrowFulfilment } =
    outletFulfilment.data.currentFulfilment

  const handleReset = () => {
    outletFulfilment.reset()
  }
  const handleCancel = () => {
    outletFulfilment.reset()
  }
  const handleDone = () => {
    serviceComponentBottomSheetController.close()
    outletFulfilment.save()
  }

  useEffect(() => {
    outletFulfilment.reset()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [serviceComponentBottomSheetController.isOpen])

  // this is the outlet fulfilment data for the saved data
  const { outlet } = outletFulfilment
  const currentFulfilmentMethodOrderability =
    outlet.orderability[
      outletFulfilment.data.currentFulfilment.narrowTypeLowerCase
    ]
  const currentFulfilmentMethodIsCurrentlyOrderable =
    currentFulfilmentMethodOrderability.asap.isAvailableNow ||
    currentFulfilmentMethodOrderability.preorder.isAvailableForSelectedDate

  return (
    <BottomSheet
      bottomSheetController={serviceComponentBottomSheetController}
      maxWidth={584}
    >
      <MobileNavigationPopoverContentWrapper>
        <MobileNavigationPopoverContent>
          {/* Fulfilment section */}
          <SectionHeader
            header={t('service_header')}
            subheader={
              currentFulfilmentMethodIsCurrentlyOrderable
                ? t('service_subheader')
                : t('service_subheader_closed')
            }
          />
          <SectionContentContainer>
            <OutletFulfilmentSection />
          </SectionContentContainer>
          {currentFulfilmentMethodIsCurrentlyOrderable && <Separator />}
          {/* End fulfilment section */}
          {/* Time Section - only display for delivery/collection when options are available */}
          {currentFulfilmentMethodIsCurrentlyOrderable &&
            currentNarrowFulfilment !==
              NarrowFulfilmentMethodInputType.TABLE && (
              <>
                <SectionHeader
                  header={t('time_header')}
                  subheader={t('time_subheader')}
                />
                <SectionContentContainer>
                  <OutletTimeSection
                    currentFulfilment={outletFulfilment.data.currentFulfilment}
                    setASAP={outletFulfilment.setASAP}
                    outlet={
                      outlet as unknown as SingleOutletWithDeliveryWindows
                    }
                  />
                </SectionContentContainer>
                <Separator />
              </>
            )}
          {/* END Time section */}
          {/* LOCATION section */}
          <AllLocationSection handleCancelWhenNavigatingAway={handleCancel} />
          {/* END LOCATION section */}
        </MobileNavigationPopoverContent>
      </MobileNavigationPopoverContentWrapper>
      {/* Footer */}
      <MobileNavigationPopoverFooter>
        <MobileNavigationPopoverFooterContent>
          <MobileNavigationResetLink onClick={handleReset}>
            {t('reset')}
          </MobileNavigationResetLink>

          <DoneButton
            content={t('done')}
            width="180px"
            onClick={handleDone}
            type={'button'}
          />
        </MobileNavigationPopoverFooterContent>
      </MobileNavigationPopoverFooter>
      {/* End Footer */}
    </BottomSheet>
  )
}
